import React from "react";
import { BillCard } from "../../components/Dashboard/bills/BillCard";
import { BillsTransactionHistory } from "../../components/Dashboard/bills/BillsTransactionHistory";
import { FaMobile, FaWifi, FaBolt, FaTv, FaCreditCard, FaDice } from "react-icons/fa";

export const BillsPage = () => {
  const billCategories = [
    {
      name: "Airtime",
      category: "airtime",
      icon: <FaMobile />,
    },
    {
      name: "Data",
      category: "data",
      icon: <FaWifi />,
    },
    {
      name: "Electricity",
      category: "electricity",
      icon: <FaBolt />,
    },
    {
      name: "TV",
      category: "tv",
      icon: <FaTv />,
    },
    {
      name: "ePins",
      category: "epins",
      icon: <FaCreditCard />,
    },
    {
      name: "Betting",
      category: "betting",
      icon: <FaDice />,
    },
  ];

  return (
    <div className="font-dashboard pt-4 pb-12 px-4 min-h-screen">
      <div className="container-lg">
        <div className="bg-black px-4 py-5">
          <h3 className="text-primary text-xl font-medium mb-8">Bill Categories</h3>
          
          <div className="w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
            {billCategories.map((category) => (
              <BillCard
                key={category.category}
                name={category.name}
                category={category.category}
                icon={category.icon}
              />
            ))}
          </div>
        </div>

        <BillsTransactionHistory />
      </div>
    </div>
  );
};

